const mimeExtensions = {
  "application/pdf": ".pdf",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
  "text/csv": ".csv",
};

const contentDispositionFilename = (value) => {
  if (!value) return "";
  const encoded = value.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch (_error) {
      return "";
    }
  }
  const quoted = value.match(/filename\s*=\s*"([^"]+)"/i);
  if (quoted) return quoted[1];
  const plain = value.match(/filename\s*=\s*([^;]+)/i);
  return plain ? plain[1].trim() : "";
};

const normalizedExtension = (value) => {
  if (!value) return "";
  const extension = String(value).trim().toLowerCase();
  return extension.startsWith(".") ? extension : `.${extension}`;
};

export const resolveDownloadFilename = (response, document = {}) => {
  const disposition = response?.headers?.get?.("content-disposition");
  const filename =
    contentDispositionFilename(disposition) ||
    String(document.displayFilename || "carbon-evidence").trim();
  if (/\.[a-z0-9]{1,10}$/i.test(filename)) return filename;
  const contentType = response?.headers?.get?.("content-type")?.split(";")[0];
  const extension =
    normalizedExtension(document.extension) || mimeExtensions[contentType] || "";
  return `${filename}${extension}`;
};

export const triggerBlobDownload = (blob, response, document = {}) => {
  const url = URL.createObjectURL(blob);
  const anchor = window.document.createElement("a");
  anchor.href = url;
  anchor.download = resolveDownloadFilename(response, document);
  anchor.style.display = "none";
  window.document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};
